/* eslint-disable consistent-return */
/* eslint-disable no-unused-expressions */
import CustomStore from 'devextreme/data/custom_store';
import { toast } from 'react-toastify';
import qs from 'qs';
import api from '~/services/api';
import { handleError, handleParams } from '~/services/helper';
import store from '~/store/Store';

export async function handleUpdateGrupoModulo(
  check,
  id,
  idGrupo,
  e,
  setLoading
) {
  const user = sessionStorage.getItem('@auth/userName');
  const moduloID = store.getState().Grupos.idModulo;
  setLoading(true);
  const group = {
    id,
    idGrupo,
    idModulo: moduloID,
    dataInclusao: new Date().toISOString(),
    usuario: user,
    check,
  };
  await api
    .put('/GrupoModulo/UpdateModulosGrupo', group)
    .then(() => {
      check
        ? toast.success('Grupo inserido com sucesso')
        : toast.info('Grupo removido com sucesso');
      setLoading(false);
      e.component.refresh();
    })
    .catch(() => {
      toast.error('Erro ao inserir');
      setLoading(false);
      e.component.refresh();
    });
}

export async function handleUpdateGrupoUsuario(
  check,
  id,
  idGrupo,
  e,
  setLoading
) {
  const user = sessionStorage.getItem('@auth/userName');
  const userID = store.getState().Grupos.idUser;
  setLoading(true);
  const group = {
    id,
    idGrupo,
    idUsuario: userID,
    dataInclusao: new Date().toISOString(),
    usuario: user,
    excluido: false,
    check,
  };
  await api
    .put('/GrupoUsuario/UpdateUsuariosGrupo', group)
    .then(() => {
      check
        ? toast.success('Grupo inserido com sucesso')
        : toast.info('Grupo removido com sucesso');
      setLoading(false);
      e.component.refresh();
    })
    .catch(() => {
      toast.error('Erro ao inserir');
      setLoading(false);
      e.component.refresh();
    });
}

export async function handleRegisterGroup(grupo, setLoading) {
  await api
    .post('/Grupo', grupo)
    .then(() => {
      toast.success('Grupo cadastrado com sucesso');
      setLoading(false);
    })
    .catch(() => {
      toast.error('Erro ao cadastrar grupo, tente novamente');
      setLoading(false);
    });
}

export async function handleDeleteGroup(setLoading) {
  setLoading(true);
  const id = store.getState().Grupos.idGroup;
  toast.info('Excluindo grupo');
  await api
    .delete(`Grupo?pId=${id}`)
    .then(() => {
      toast.success('Grupo excluido com sucesso');
      setLoading(false);
    })
    .catch(() => {
      toast.error(
        'Erro ao excluir grupo, tente novamente ou recarregue a página'
      );
    });
}

export async function handleUpdateGroup(grupo, setLoading) {
  await api
    .put('/Grupo', grupo)
    .then(() => {
      toast.success('Dados do grupo atualizado com sucesso');
      setLoading(false);
    })
    .catch(() => {
      toast.error('Erro ao atualizar dados do grupo');
      setLoading(false);
    });
}

export async function handleUpdateGrupoSubMenu(
  check,
  id,
  idMenuSub,
  e,
  form,
  setLoading
) {
  const user = sessionStorage.getItem('@auth/userName');
  const { idGroup } = store.getState().Grupos;
  setLoading(true);
  const group = {
    id,
    idMenuSub,
    idPagina: 1,
    idGrupo: idGroup,
    ler: form.ler,
    incluir: form.incluir,
    atualizar: form.atualizar,
    deletar: form.deletar,
    upload: form.upload,
    download: form.download,
    outros: form.outros,
    dataInclusao: new Date().toISOString(),
    usuario: user,
    excluido: false,
    check,
  };
  await api
    .put('/PermissaoGrupo/UpdatePermissaoGrupo', group)
    .then(() => {
      check
        ? toast.success('Grupo inserido com sucesso')
        : toast.info('Grupo removido com sucesso');
      setLoading(false);
      e.component.refresh();
    })
    .catch(() => {
      toast.error('Erro ao inserir');
      setLoading(false);
      e.component.refresh();
    });
}

async function handleLoadGrupoModuloData(loadOptions) {
  const { idModulo, idPessoaEmpresa } = store.getState().Grupos;
  const params = {
    idPessoaEmpresa,
    idModulo,
    check: null,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `GrupoModulo/GetModulosGrupo?${qs.stringify(newParams)}`;
  try {
    const res = await api.get(url);
    const { data, totalCount } = res.data;
    return {
      data,
      totalCount,
    };
  } catch (err) {
    handleError('Erro ao carregar', err);
  }
}

export const gridGroupModuloDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadGrupoModuloData(loadOptions),
  }),
};

async function handleLoadGrupoUserData(loadOptions) {
  const { idPessoaEmpresa, idUser } = store.getState().Grupos;
  const params = {
    idPessoaEmpresa,
    idUsuario: idUser,
    check: null,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `GrupoUsuario/GetUsuariosGrupo?${qs.stringify(newParams)}`;
  try {
    const res = await api.get(url);
    const { data, totalCount } = res.data;
    return {
      data,
      totalCount,
    };
  } catch (err) {
    handleError('Erro ao carregar', err);
  }
}

export const gridGroupUserDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadGrupoUserData(loadOptions),
  }),
};

async function handleLoadGroupSubMenuData(loadOptions) {
  const { idMenu, idGroup } = store.getState().Grupos;
  const params = {
    idMenu,
    idGrupo: idGroup,
    check: null,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `PermissaoGrupo/GetPermissaoGrupo?${qs.stringify(newParams)}`;
  try {
    const res = await api.get(url);
    const { data, totalCount } = res.data;
    return {
      data,
      totalCount,
    };
  } catch (err) {
    handleError('Erro ao carregar', err);
  }
}

export const gridGroupSubMenuDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadGroupSubMenuData(loadOptions),
  }),
};

async function handleLoadUserData(loadOptions) {
  const companyID = JSON.parse(sessionStorage.getItem('@auth/empresa'));
  const params = {
    idEmpresa: companyID,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `/Usuario/GetUsuarioByEmpresa?${qs.stringify(newParams)}`;
  try {
    const res = await api.get(url);
    const { data, totalCount } = res.data;
    return {
      data,
      totalCount,
    };
  } catch (err) {
    handleError('Erro ao carregar', err);
  }
}

export const gridUserDataSource = {
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadUserData(loadOptions),
  }),
};

async function handleLoadGroupData(loadOptions, idPessoaEmpresa) {
  const params = {
    idEmpresa: idPessoaEmpresa,
  };
  const newParams = handleParams(params, loadOptions);
  const url = `/Grupo/GetByEmpresa?${qs.stringify(newParams)}`;
  try {
    const res = await api.get(url);
    const { data, totalCount } = res.data;
    return {
      data,
      totalCount,
    };
  } catch (err) {
    handleError('Erro ao carregar', err);
  }
}

async function handleDeleteGroupGrid(key) {
  const url = `Grupo?pId=${key}`;
  return api
    .delete(url)
    .then(() => {
      toast.success('Grupo deletado com sucesso');
    })
    .catch((err) => handleError(err));
}

export const gridGroupDataSource = (idPessoaEmpresa) => ({
  store: new CustomStore({
    key: 'id',
    load: (loadOptions) => handleLoadGroupData(loadOptions, idPessoaEmpresa),
    remove: (key) => handleDeleteGroupGrid(key),
  }),
});
